import { render } from "./LanguageGroupListDropdown.vue?vue&type=template&id=650dcf1c"
import script from "./LanguageGroupListDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageGroupListDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__